import { InventoryManager } from "@/pages/InventoryManager";

export default function PartnerInventory() {
  return <InventoryManager scope="partner" />;
}
